export const tinkGreen = {
  100: '#F5F8F9',
  200: '#ECF1F2',
  300: '#D9E4E6',
  400: '#A0BBC1',
  500: '#7BA0A8',
  600: '#427783',
  700: '#2D5D67',
  800: '#00414B',
  900: '#001A1E',
};
